import React from 'react';

function ServicesAbout() {
    return (
        <>
            <section className="appie-services-2-area bg-light pt-90 pb-55" id="service">
                <div className="container">
                    <div className="row align-items-end">
                        <div className="col-lg-6 col-md-8">
                            <div className="appie-section-title">
                                <h3 className="appie-title">Features</h3>
                                <p>
                                    Our POS App comes with a variety of features, below is a list of
                                    the main features of our app.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-4 col-md-6">
                            <div
                                className="appie-single-service-2 appie-single-service-about mt-30 wow animated fadeInUp"
                                data-wow-duration="2000ms"
                                data-wow-delay="200ms"
                            >
                                <div className="icon">
                                    <i className="fal fa-utensils-alt"></i>
                                </div>
                                <h4 className="title">Order Taking</h4>
                                <p>
                                    Our app allows waiters to take customer orders quickly and
                                    efficiently, with a simple and intuitive interface that reduces
                                    the potential for errors.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div
                                className="appie-single-service-2 appie-single-service-about item-2 mt-30 wow animated fadeInUp"
                                data-wow-duration="2000ms"
                                data-wow-delay="400ms"
                            >
                                <div className="icon">
                                    <i className="fal fa-compress-arrows-alt"></i>
                                </div>
                                <h4 className="title">Integration</h4>
                                <p>
                                    Our POS app is designed to integrate seamlessly with inventory
                                    and hotel rooms management apps
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div
                                className="appie-single-service-2 appie-single-service-about item-3 mt-30 wow animated fadeInUp"
                                data-wow-duration="2000ms"
                                data-wow-delay="600ms"
                            >
                                <div className="icon">
                                    <i className="fal fa-file-chart-line"></i>
                                </div>
                                <h4 className="title">Reporting and analytics</h4>
                                <p>
                                    Our app provides you with valuable insights into your sales data
                                    and inventory levels, allowing you to make data-driven decisions
                                    to grow your business.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div
                                className="appie-single-service-2 appie-single-service-about item-4 mt-30 wow animated fadeInUp"
                                data-wow-duration="2000ms"
                                data-wow-delay="200ms"
                            >
                                <div className="icon">
                                    <i className="fal fa-cheeseburger"></i>
                                </div>
                                <h4 className="title">Menu customization</h4>
                                <p>
                                    Our app allows businesses to customize menus, making it easy to
                                    update pricing, add new items, and manage inventory.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div
                                className="appie-single-service-2 appie-single-service-about item-5 mt-30 wow animated fadeInUp"
                                data-wow-duration="2000ms"
                                data-wow-delay="400ms"
                            >
                                <div className="icon">
                                    <i className="fal fa-boxes"></i>
                                </div>
                                <h4 className="title">Inventory management</h4>
                                <p>
                                    Our app can help businesses manage inventory for their
                                    restaurants and bars, generating real-time reports on sales and
                                    profitability.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div
                                className="appie-single-service-2 appie-single-service-about item-6 mt-30 wow animated fadeInUp"
                                data-wow-duration="2000ms"
                                data-wow-delay="600ms"
                            >
                                <div className="icon">
                                    <i className="fal fa-chair"></i>
                                </div>
                                <h4 className="title">Table management</h4>
                                <p>
                                    Our POS app helps businesses manage table reservations,
                                    waitlists, and seating arrangements, making it easy to optimize
                                    the dining experience for guests.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default ServicesAbout;
